import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import idssStyle from "../../Configuration/SharedStyling";
import { createStyles, withStyles, Theme, WithStyles } from "@material-ui/core/styles";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../DataClasses/GenericUser";
import { Button, Fade, Grid, IconButton, Paper, Tooltip, Zoom } from "@material-ui/core";
import LoadingDataTable from "../Shared/LoadingDataTable";
import MUIDataTable, { MUIDataTableColumn, MUIDataTableOptions } from "mui-datatables";
import GetAppIcon from '@material-ui/icons/GetApp';
import { firstValueFrom } from "rxjs";
import { AjaxError } from "rxjs/ajax";
import ReportsService from "../Services/ReportsService";
import { IHistoricalFileDetail, IMYSub } from "../../DataClasses/HistoricalFile";
import { SeedTime } from "../../Configuration/Setting";
import Select from "react-select";


const CustomToolbar = ({ canDownloadAll, onDownloadAll }: { canDownloadAll: boolean; onDownloadAll: () => void }) => (
    <Button
      style={{ display: canDownloadAll ? "inline-flex" : "none" }}
      variant="contained"
      color="primary"
      onClick={onDownloadAll}
    >
      Download All
    </Button>
  );

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 0,
        padding: theme.spacing(2, 2),
        width: "100%"
    }
});

const GradualDisplay = {
    gradualDisplay: {
        animation: 'gradualShowTopToBottom 1s ease-in-out forwards',
    },
};

const css = `
@keyframes gradualShowTopToBottom {
  from {
    transform: translateY(-50px); 
    opacity: 0;
  }
  to {
    transform: translateY(0); 
    opacity: 1;
  }
}
`;


// Inject the CSS into the document's head
const GradualDisplaySheet = document.createElement("style");
GradualDisplaySheet.innerText = css;
document.head.appendChild(GradualDisplaySheet);

type IStylesProps = WithStyles<typeof styles>;

interface IUserHistoricalFilesStateStore {
    isLoading: boolean;
    redirect: boolean;
    tableData: IHistoricalFileDetail[];
    mysSubIds: IMYSub[];
    selectedMys: any;
    selectedSubIds: any;
    showTable: boolean;
    notAvailable: boolean;
}
class UserHistoricalFilesView extends React.Component<
    IGenericUserProps & IStylesProps,
    IUserHistoricalFilesStateStore
    > {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            redirect: false,
            tableData: [],
            mysSubIds: [],
            selectedMys: "",
            selectedSubIds: "",
            showTable: false,
            notAvailable: false
        }
    }

    public async componentDidMount() {
        let mysSubIds = await firstValueFrom(ReportsService.UserGetHistoricalFileMYSubList$(this.props.user));
        if (mysSubIds instanceof AjaxError) {
            this.setRedirectState();
        }
        else {
            if (mysSubIds.length < 1) {
                this.setState({ notAvailable: true })
            }
            this.setState({ mysSubIds: mysSubIds });
        }
    }

    private async RefreshTable() {
        this.setState({ isLoading: true });
        let mys = this.state.selectedMys.map(my => my.value).join(",");
        let subIds : string = "";
        if (Array.isArray(this.state.selectedSubIds) && this.state.selectedSubIds.length > 0) { 
           subIds = this.state.selectedSubIds.map(subId => subId.value).join(",");
        }
        let historicalFiles = await firstValueFrom(ReportsService.UserGetHistoricalFileList$(this.props.user, mys, subIds));
        if (historicalFiles instanceof AjaxError) {
            this.setRedirectState();
        }
        else {
            this.setState({ tableData: historicalFiles, isLoading: false });
        }
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }


    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const ftOptions: MUIDataTableOptions = {
            filter: true,
            filterType: "dropdown",
            responsive: "standard",
            selectableRows: "none",
            download: false,
            print: false,
            viewColumns: false,
            rowsPerPage: 10,
            rowsPerPageOptions: [10, 20, 50],
            textLabels: {
                body: {
                    noMatch: (
                        <span>
                            No historical files are available. If you have any questions, please contact us through &nbsp;
                            <a href={process.env.REACT_APP_MEDIA_NCQA_MY + 'Questions'} target="_blank" rel="noopener noreferrer">
                                <u>My.Ncqa</u>
                            </a>.
                        </span>
                    ),
                }
            },
            customToolbar: () => <CustomToolbar canDownloadAll={this.canDownloadAll()} onDownloadAll={() => this.downloadAll()} />,
        };
        const { classes } = this.props;
        const yearOptions = this.getYearOptions();
        const subOptions = this.getSubIdOptions();
        return <Grid container={true} spacing={2} className={classes.mainPanel + " " + classes.root}>
            <Grid item={true} xs={12}>
                {this.state.notAvailable ?
                    <Paper className={classes.paperStyle}>
                        <h6>
                            No historical files are available for this account. If you have any questions, please contact us through &nbsp;
                            <a href={process.env.REACT_APP_MEDIA_NCQA_MY + 'Questions'} target="_blank" rel="noopener noreferrer">
                                <u>My.Ncqa</u>
                            </a>.
                        </h6>
                    </Paper>
                    :
                    <Paper className={classes.paperStyle}>
                        <table><tbody><tr>
                            <td style={{ width: "175px" }} >Select Measurement Year(s): </td>
                            <td style={{ width: "30%" }}>
                                <Select
                                    options={yearOptions}
                                    placeholder="Select MeasurementYear(s)"
                                    isMulti={true}
                                    matchProp="label"
                                    simpleValue={true}
                                    value={this.state.selectedMys}
                                    closeOnSelect={false}
                                    searchable={true}
                                    onChange={this.selectedMyChange.bind(this)}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </td>
                            <td style={{ width: "10px" }} ></td>
                            <td style={{ width: "70px" }} >SubID(s): </td>
                            <td style={{ width: "30%" }}>
                                <Tooltip title={this.state.selectedMys.length === 0 ? "Select MeasurementYear(s) to Enable me" : ""} placement="top">
                                    <div style={{ display: 'inline-block', width: '100%' }}>
                                <Select
                                    isDisabled={this.state.selectedMys.length === 0}
                                    options={subOptions}
                                    placeholder={"Select SubId(s) or leave it to get all"}
                                    isMulti={true}
                                    matchProp="label"
                                    simpleValue={true}
                                    value={this.state.selectedSubIds}
                                    closeOnSelect={false}
                                    searchable={true}
                                    onChange={this.selectedSubIdsChange.bind(this)}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </Tooltip>
                            </td>
                            <td style={{ width: "10px" }} ></td>
                            <td style={{ width: "90px" }}>
                                <Tooltip title={this.state.selectedMys.length === 0 ? "Select MeasurementYear(s) to Enable me" : ""} placement="top">
                                    <div style={{ display: 'inline-block' }}>
                                        <Button
                                            onClick={() => this.getFileList()}
                                            disabled={this.state.selectedMys.length === 0 || this.state.isLoading}
                                        >
                                            Get Files
                                        </Button>
                                    </div>
                                </Tooltip>
                            </td>
                        </tr></tbody></table><br />
                        {this.state.showTable && (
                            this.state.isLoading ?
                                <LoadingDataTable titleText={"*"} />
                                : (
                                    <Fade in={true} timeout={SeedTime}>
                                        <Zoom in={true} style={{ transitionDelay: '600ms' }}>
                                            <div style={GradualDisplay.gradualDisplay}>
                                                <MUIDataTable
                                                    title={"Available Historical Files"}
                                                    data={this.state.tableData}
                                                    columns={this.getTableColumns()}
                                                    options={ftOptions}
                                                />
                                            </div>
                                        </Zoom>
                                    </Fade>))}
                    </Paper>
                }
                  </Grid>
            </Grid>
    }
    private async getFileList() {
        this.RefreshTable();
        this.setState({ showTable: true });
    }

    private selectedMyChange(mys: any) {
        this.setState({ selectedMys: mys });
        if (Array.isArray(this.state.selectedSubIds) && this.state.selectedSubIds.length > 0) {
            let applicableSubIds = this.state.mysSubIds.filter(x => mys.map(y => y.value).includes(x.measurementYear)).map(x => x.submissionId);
            let selectedSubIds = this.state.selectedSubIds.filter(x => applicableSubIds.includes(x.value));
            this.setState({ selectedSubIds: selectedSubIds });
        }
    }

    private selectedSubIdsChange(subIds: any) {
        this.setState({ selectedSubIds: subIds });
    }

    private getYearOptions() {
        let mys = [...new Set(this.state.mysSubIds.map(x => x.measurementYear))]
            .sort((a, b) => b - a);            ;

        const retval = mys.map(my => ({ value: my, label: my.toString() }));

        return retval;
    }
    private getSubIdOptions() {
        const selectedMyValues = Array.isArray(this.state.selectedMys) ? this.state.selectedMys.map(x => x.value) : [];
        const subIds = [...new Set(this.state.mysSubIds
            .filter(x => selectedMyValues.includes(x.measurementYear))
            .map(x => x.submissionId)
        )].sort((a, b) => a - b);
        
        const retval = subIds.map(subId => ({ value: subId, label: subId.toString() }));
        return retval;
    }

    private renderCustomDownloadButton(value: number, tableMeta: any) {
        let tipTxt = "Download File";
        if (value <= 0) {
            return (
                <div>
                    File not found
                </div>
            );
        } else {
            return (
                <div>
                    <Tooltip title={tipTxt} aria-label={tipTxt}>
                        <IconButton onClick={() => this.downloadFile(value, tableMeta.rowData)}>
                            <GetAppIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
    };
    private getTableColumns() {
        return [
            {
                name: "measurementYear",
                label: "Measurement Year",
            },
            {
                name: "orgId",
                label: "Org ID",
            },
            {
                name: "submissionId",
                label: "Sub ID",
            },
            {
                name: "orgName",
                label: "Org Name",
            },  
            {
                name: "productLine",
                label: "Product Line",
            },
            {
                name: "reportingProduct",
                label: "Reporting Product",
            },
            {
                name: "fileType",
                label: "File Type",
            },
            {
                name: "fileTypeId",
                label: "Download",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta) => this.renderCustomDownloadButton(value, tableMeta),
                    download: false
                }
            },
        ] as MUIDataTableColumn[];
    }

    private downloadFile = async (fileTypeId: number, rowData: any): Promise<void> => {
        let fileUrl = await this.getDownloadUrl(rowData[0], rowData[2], fileTypeId);
        window.location.href = fileUrl;
    }
    private getDownloadUrl = async (measurementYear: number, submissionId: number, fileTypeId: number): Promise<string> => {
        let retval = await firstValueFrom(ReportsService.GetUserHistoricalFileDownloadUrl$(this.props.user, measurementYear, submissionId, fileTypeId));
        return retval;
    }

    private canDownloadAll = () => {
        if(this.state.tableData.length == 0) return false;

        return this.state.tableData.some(x => x.fileTypeId > 0);
    }

    private downloadAll = async(): Promise<void> => {   
        try {
            const response = await firstValueFrom(
                ReportsService.GetHistoricalFilesZip(this.props.user, this.state.tableData)
            );
    
            const blob = new Blob([response.response as ArrayBuffer], { type: 'application/zip' });
    
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = 'historicalFiles.zip';

            document.body.appendChild(link);

            link.click();
    
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading ZIP file:", error);
        }
          
    }

}

// REDUX CONTAINER
const UserHistoricalFilesWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(UserHistoricalFilesView);

// STYLES CONTAINER
const UserHistoricalFilesPage = withStyles(styles)(UserHistoricalFilesWithState);

export default UserHistoricalFilesPage;